// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editTextArticle{
    width: 100%;
    height: fit-content;
    display: flex;
    flex-direction: column;
    gap: 22px;
    padding-left: 142px;
    padding-right: 142px;
}

.editTextArticle > h1{
    font-size: 20px;
    font-weight: 600;
    color: #000000;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.newsTitle > p{
    font-size: 16px;
    font-weight: 500;
    color: #000000;
}

.newsTitleInput{
    border: 1px solid #515151;
    width: 100%;
    height: 44px;
    padding: 5px 11px;
    border-radius: 6px;
    background-color: transparent;
    color: #515151;
    font-size: 16px;
    font-weight: 500;
}

.error {
    color:  #D80303;
    font-size: 16px;
    margin-bottom: 0 !important;
}
.uploadImageIcon{
    border: 1px solid #515151;
    width: 100%;
    height: 44px;
    border-radius: 6px;
    background-color: transparent;
    color: #515151;
    font-size: 16px;
    font-weight: 500;
    padding: 0px 11px;

    display: flex;
    justify-content: space-between;
    align-items: center;
}
.uploadImageIcon > input:first-child{
    width: 90%;
    height: 100%;
    padding: 5px 0px;
    border: none;
    border-radius: inherit;
    outline: none;
    /* z-index: -1; */
    background-color: transparent;
}

.ql-snow .ql-picker.ql-expanded .ql-picker-options {
 
    background: white !important;
}


.ql-header .ql-picker{
    width: 122px;
}
.fileUploadMainInput{
    z-index: -1;
    width: 0px;
    border: 1px solid black;
}

.uploadImageIcon svg{
    cursor: pointer;
}

.textArticleEditorBox{
    width: 100%;
    height: fit-content;
}

.textArticleEditorBox > h1{
    color: #000000;
    font-weight: 500;
    font-size: 16px;
}
.textArticleEditorBox > .rsw-editor{
    height: 256px;
    border: 1px solid #515151;
    overflow-y: auto;
}
.textArticleEditorBox > .rsw-editor > .rsw-toolbar{
    border-bottom: 2px solid #515151;
}

.textArticleEditorBox > .rsw-editor::-webkit-scrollbar{
    width: 5px;
    background-color: rgb(159, 156, 156);
    height: 100%;
    border-top-right-radius: inherit;
    border-bottom-right-radius: inherit;
}
.textArticleEditorBox > .rsw-editor::-webkit-scrollbar-thumb{
    width: 8px;
    height: 10px;
    background-color: #000;
    border-radius: inherit;
}

.editNews{
font-family: Quicksand;
font-size: 20px;
font-weight: 600;

}
.ql-snow .ql-picker.ql-header{
    width: 122px !important;
}

.ql-editor.ql-blank::before {
    color: #515151;
    font-style: normal !important;
    right: 15px;
    font-family: Quicksand;
    font-size: 16px;
    font-weight: 500;
}

.p-component.p-editor-container {
    border: 1px solid #515151;
    border-radius: 8px;
    border: 1px solid #515151;
}


.ql-toolbar.ql-snow {
    border: transparent !important;
    font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
    /* padding: 8px; */
    border-top: none !important;
    border-bottom: 2px solid #515151 !important;
}
.editNewsHeader {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 0px !important;
    cursor: pointer;
}
/* Target the toolbar container */
.p-editor-toolbar .ql-formats {
    display: flex !important;
    align-items: center;
    gap: 10px; /* Add some spacing between the buttons */
}

/* Styles for the header dropdown */
.p-editor-toolbar .ql-header {
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 5px;
    font-size: 14px;
}

/* Styles for the size dropdown */
.p-editor-toolbar .ql-size {
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 5px;
    font-size: 14px;
}

/* Styles for the bold button */
.p-editor-toolbar .ql-bold {
    background-color: #f1f1f1;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 5px;
}

/* Styles for the italic button */
.p-editor-toolbar .ql-italic {
    background-color: #f1f1f1;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 5px;
}

/* Styles for the underline button */
.p-editor-toolbar .ql-underline {
    background-color: #f1f1f1;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 5px;
}
#ql-picker-options-1 {
    background: white;
}

#ql-picker-options-0 {
    background: white;
}

/* Styles for the link button */
.p-editor-toolbar .ql-link {
    background-color: #f1f1f1;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 5px;
}


.ql-snow .ql-picker{
    height: auto !important;
}
/* Styles for the image button */
.p-editor-toolbar .ql-image {
    background-color: #f1f1f1;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 5px;
}
.ql-header.ql-picker{
    height:auto !important ;
}
/* Add hover effects */
.p-editor-toolbar .ql-header:hover,
.p-editor-toolbar .ql-size:hover,
.p-editor-toolbar .ql-bold:hover,
.p-editor-toolbar .ql-italic:hover,
.p-editor-toolbar .ql-underline:hover,
.p-editor-toolbar .ql-link:hover,
.p-editor-toolbar .ql-image:hover {
    background-color: #e0e0e0;
}

/* Add active state styles */
.p-editor-toolbar .ql-header.ql-active,
.p-editor-toolbar .ql-size.ql-active,
.p-editor-toolbar .ql-bold.ql-active,
.p-editor-toolbar .ql-italic.ql-active,
.p-editor-toolbar .ql-underline.ql-active,
.p-editor-toolbar .ql-link.ql-active,
.p-editor-toolbar .ql-image.ql-active {
    background-color: #d0d0d0;
}
.editBtn{
    width: 100% ;
    display: flex;
    justify-content: center;
}

@media screen and (max-width:851px) {
    .editTextArticle{
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/News/EditArticles.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;IAC7B,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,2BAA2B;AAC/B;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;;IAEjB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;;IAEI,4BAA4B;AAChC;;;AAGA;IACI,YAAY;AAChB;AACA;IACI,WAAW;IACX,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,oCAAoC;IACpC,YAAY;IACZ,gCAAgC;IAChC,mCAAmC;AACvC;AACA;IACI,UAAU;IACV,YAAY;IACZ,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;AACA,sBAAsB;AACtB,eAAe;AACf,gBAAgB;;AAEhB;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,WAAW;IACX,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;AAC7B;;;AAGA;IACI,8BAA8B;IAC9B,+DAA+D;IAC/D,kBAAkB;IAClB,2BAA2B;IAC3B,2CAA2C;AAC/C;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,6BAA6B;IAC7B,eAAe;AACnB;AACA,iCAAiC;AACjC;IACI,wBAAwB;IACxB,mBAAmB;IACnB,SAAS,EAAE,yCAAyC;AACxD;;AAEA,mCAAmC;AACnC;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA,iCAAiC;AACjC;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA,+BAA+B;AAC/B;IACI,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;AAChB;;AAEA,iCAAiC;AACjC;IACI,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;AAChB;;AAEA,oCAAoC;AACpC;IACI,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,+BAA+B;AAC/B;IACI,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;AAChB;;;AAGA;IACI,uBAAuB;AAC3B;AACA,gCAAgC;AAChC;IACI,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,uBAAuB;AAC3B;AACA,sBAAsB;AACtB;;;;;;;IAOI,yBAAyB;AAC7B;;AAEA,4BAA4B;AAC5B;;;;;;;IAOI,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI;QACI,WAAW;IACf;AACJ","sourcesContent":[".editTextArticle{\n    width: 100%;\n    height: fit-content;\n    display: flex;\n    flex-direction: column;\n    gap: 22px;\n    padding-left: 142px;\n    padding-right: 142px;\n}\n\n.editTextArticle > h1{\n    font-size: 20px;\n    font-weight: 600;\n    color: #000000;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n}\n\n.newsTitle > p{\n    font-size: 16px;\n    font-weight: 500;\n    color: #000000;\n}\n\n.newsTitleInput{\n    border: 1px solid #515151;\n    width: 100%;\n    height: 44px;\n    padding: 5px 11px;\n    border-radius: 6px;\n    background-color: transparent;\n    color: #515151;\n    font-size: 16px;\n    font-weight: 500;\n}\n\n.error {\n    color:  #D80303;\n    font-size: 16px;\n    margin-bottom: 0 !important;\n}\n.uploadImageIcon{\n    border: 1px solid #515151;\n    width: 100%;\n    height: 44px;\n    border-radius: 6px;\n    background-color: transparent;\n    color: #515151;\n    font-size: 16px;\n    font-weight: 500;\n    padding: 0px 11px;\n\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n.uploadImageIcon > input:first-child{\n    width: 90%;\n    height: 100%;\n    padding: 5px 0px;\n    border: none;\n    border-radius: inherit;\n    outline: none;\n    /* z-index: -1; */\n    background-color: transparent;\n}\n\n.ql-snow .ql-picker.ql-expanded .ql-picker-options {\n \n    background: white !important;\n}\n\n\n.ql-header .ql-picker{\n    width: 122px;\n}\n.fileUploadMainInput{\n    z-index: -1;\n    width: 0px;\n    border: 1px solid black;\n}\n\n.uploadImageIcon svg{\n    cursor: pointer;\n}\n\n.textArticleEditorBox{\n    width: 100%;\n    height: fit-content;\n}\n\n.textArticleEditorBox > h1{\n    color: #000000;\n    font-weight: 500;\n    font-size: 16px;\n}\n.textArticleEditorBox > .rsw-editor{\n    height: 256px;\n    border: 1px solid #515151;\n    overflow-y: auto;\n}\n.textArticleEditorBox > .rsw-editor > .rsw-toolbar{\n    border-bottom: 2px solid #515151;\n}\n\n.textArticleEditorBox > .rsw-editor::-webkit-scrollbar{\n    width: 5px;\n    background-color: rgb(159, 156, 156);\n    height: 100%;\n    border-top-right-radius: inherit;\n    border-bottom-right-radius: inherit;\n}\n.textArticleEditorBox > .rsw-editor::-webkit-scrollbar-thumb{\n    width: 8px;\n    height: 10px;\n    background-color: #000;\n    border-radius: inherit;\n}\n\n.editNews{\nfont-family: Quicksand;\nfont-size: 20px;\nfont-weight: 600;\n\n}\n.ql-snow .ql-picker.ql-header{\n    width: 122px !important;\n}\n\n.ql-editor.ql-blank::before {\n    color: #515151;\n    font-style: normal !important;\n    right: 15px;\n    font-family: Quicksand;\n    font-size: 16px;\n    font-weight: 500;\n}\n\n.p-component.p-editor-container {\n    border: 1px solid #515151;\n    border-radius: 8px;\n    border: 1px solid #515151;\n}\n\n\n.ql-toolbar.ql-snow {\n    border: transparent !important;\n    font-family: \"Helvetica Neue\", \"Helvetica\", \"Arial\", sans-serif;\n    /* padding: 8px; */\n    border-top: none !important;\n    border-bottom: 2px solid #515151 !important;\n}\n.editNewsHeader {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    margin-bottom: 0px !important;\n    cursor: pointer;\n}\n/* Target the toolbar container */\n.p-editor-toolbar .ql-formats {\n    display: flex !important;\n    align-items: center;\n    gap: 10px; /* Add some spacing between the buttons */\n}\n\n/* Styles for the header dropdown */\n.p-editor-toolbar .ql-header {\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    padding: 5px;\n    font-size: 14px;\n}\n\n/* Styles for the size dropdown */\n.p-editor-toolbar .ql-size {\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    padding: 5px;\n    font-size: 14px;\n}\n\n/* Styles for the bold button */\n.p-editor-toolbar .ql-bold {\n    background-color: #f1f1f1;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    padding: 5px;\n}\n\n/* Styles for the italic button */\n.p-editor-toolbar .ql-italic {\n    background-color: #f1f1f1;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    padding: 5px;\n}\n\n/* Styles for the underline button */\n.p-editor-toolbar .ql-underline {\n    background-color: #f1f1f1;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    padding: 5px;\n}\n#ql-picker-options-1 {\n    background: white;\n}\n\n#ql-picker-options-0 {\n    background: white;\n}\n\n/* Styles for the link button */\n.p-editor-toolbar .ql-link {\n    background-color: #f1f1f1;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    padding: 5px;\n}\n\n\n.ql-snow .ql-picker{\n    height: auto !important;\n}\n/* Styles for the image button */\n.p-editor-toolbar .ql-image {\n    background-color: #f1f1f1;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    padding: 5px;\n}\n.ql-header.ql-picker{\n    height:auto !important ;\n}\n/* Add hover effects */\n.p-editor-toolbar .ql-header:hover,\n.p-editor-toolbar .ql-size:hover,\n.p-editor-toolbar .ql-bold:hover,\n.p-editor-toolbar .ql-italic:hover,\n.p-editor-toolbar .ql-underline:hover,\n.p-editor-toolbar .ql-link:hover,\n.p-editor-toolbar .ql-image:hover {\n    background-color: #e0e0e0;\n}\n\n/* Add active state styles */\n.p-editor-toolbar .ql-header.ql-active,\n.p-editor-toolbar .ql-size.ql-active,\n.p-editor-toolbar .ql-bold.ql-active,\n.p-editor-toolbar .ql-italic.ql-active,\n.p-editor-toolbar .ql-underline.ql-active,\n.p-editor-toolbar .ql-link.ql-active,\n.p-editor-toolbar .ql-image.ql-active {\n    background-color: #d0d0d0;\n}\n.editBtn{\n    width: 100% ;\n    display: flex;\n    justify-content: center;\n}\n\n@media screen and (max-width:851px) {\n    .editTextArticle{\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
